<!--
 * @Description: 登录页面
 * @Date: 2019-08-20 15:40:11
 * @LastEditTime: 2021-08-13 10:16:04
 -->
<template>
  <div id="login" class="container">
    <!-- S 顶部logo -->
    <div class="header">
      <img v-if="domainType() === 1" class="logo" src="~assets/imgs/new-logo.png" alt="logo">
      <img v-else-if="domainType() === 2" class="logo" src="~assets/imgs/cec-logo1.png" alt="logo">
      <img v-else class="logo" src="~assets/imgs/new-logo2.png" alt="logo">
    </div>
    <!-- E 顶部logo -->

    <div class="wallpaper">
      <!-- S 登录背景 -->
      <!-- <img class="login-bg" :src="loginBg"> -->
      <div class="login-bg" />
      <!-- E 登录背景 -->

      <!-- S 登录表单 -->
      <div class="form-content">
        <el-form ref="form" :model="form" :rules="rules" label-width="0">
          <div class="title">
            新型泄密溯源取证云平台
          </div>
          <el-form-item prop="username" class="account">
            <el-input
              v-model="form.username"
              placeholder="请输入账号"
              @keyup.enter.native="submitForm('form')"
            />
          </el-form-item>
          <el-form-item prop="password" class="pwd">
            <el-input
              v-model="form.password"
              type="password"
              placeholder="请输入密码"
              autocomplete="off"
              auto-complete="new-password"
              @keyup.enter.native="submitForm('form')"
            />
          </el-form-item>
          <div class="link">
            <router-link to="/forgetPsd" class="link-to">
              忘记密码?
            </router-link>
          </div>
          <el-form-item>
            <el-button
              type="primary"
              :loading="submitLoading"
              class="login-btn"
              @click="submitForm('form')"
            >
              登录
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- E 登录表单 -->
    </div>
    <div class="introduce">
      <!-- S 平台介绍 -->
      <dl class="introduce-item">
        <dt>平台介绍</dt>
        <dd>
          <ul>
            <li>
              <p>溯源取证云平台是为屏幕拍摄泄密、文档打印泄密、文件流转泄密等溯源管理产品提供集中取证服务的平台，能对文件、拍屏、截屏、打印件及其照片、复印件及其照片中含有的安全标识信息或流转信息进行提取。</p>
            </li>
            <li style="text-align: center">
              <img src="http://www.hddata.cn/img/product/75.jpg">
            </li>
          </ul>
        </dd>
      </dl>
      <!-- /平台介绍 -->
      <dl class="introduce-item">
        <dt>平台功能</dt>
        <dd>
          <h4 class="thd-tt">
            +取证对象导入
          </h4>
          <ul class="text-list">
            <li>(1)用户登录溯源取证云平台，可手动导入取证。</li>
            <li>(2)泄密发现系统从终端设备及互联网节点数据中发现的可疑文件自动推送至溯源取证云平台。</li>
          </ul>
          <h4 class="thd-tt">
            +溯源取证
          </h4>
          <ul class="text-list">
            <li>(1)自助取证：用户可根据平台提示自行完成泄密图片或泄密文件的溯源取证。</li>
            <li>(2)深度取证：对于自助取证不成功的图片或文件，可申请深度取证服务，由取证技术人员提供专业服务。</li>
          </ul>
          <h4 class="thd-tt">
            +取证结果通知及导出
          </h4>
          <ul class="text-list">
            <li>(1)通过登录泄密取证云平台，手动上传的泄密图取证结果，会邮件通知平台用户，取证结果可导出。</li>
            <li>(2)泄密发现系统发现疑似泄密文件后，第一时间通知相关安全部门。</li>
          </ul>
        </dd>
      </dl>
      <!-- /平台功能 -->
      <dl class="introduce-item">
        <dt>平台特色</dt>
        <dd>
          <ul>
            <li style="text-align: center;">
              <img src="http://www.hddata.cn/img/product/76.jpg">
            </li>
          </ul>
        </dd>
      </dl>
      <!-- /平台特色 -->
      <dl class="introduce-item">
        <dt>用户代表说</dt>
        <dd>
          <ul>
            <li>
              <p>
                屏幕是突破物理隔离的重要出口，敏感信息、涉密信息被偷拍造成泄密是一直的困扰，该系统可以实现分钟级溯源，震慑作用明显，是保密管理重要的抓手。
              </p>
              <p class="company-name">
                <i class="user-icon" />(某涉密单位)
              </p>
            </li>
            <li>
              <p>
                借助取证系统，仅需一张拍屏图片我们即可定位到设备使用者，这对员工的泄密行为形成了极大的威慑力，目前单位员工都会有意识的不随意拍屏、截图，并且会主动保护屏幕不被偷拍，员工的屏幕显示安全意识得到了大幅提升。
              </p>
              <p class="company-name">
                <i class="user-icon" />(某金融机构)
              </p>
            </li>
            <li>
              <p>
                通过取证系统分析网络流传的图片，我们有效的管控了失泄密的源头，员工随意拍屏和截图的习惯得到了纠正，致使拍屏泄密行为得到了有效扼制，单位机密信息图在网络上流传的数量明显减少。
              </p>
              <p class="company-name">
                <i class="user-icon" />(某研究所)
              </p>
            </li>
          </ul>
        </dd>
      </dl>
      <!-- /用户代表语录 -->
      <dl v-if="domainType() === 1" class="introduce-item">
        <dt>联系我们</dt>
        <dd>
          <ul style="display: block;margin:0 auto;width:240px;">
            <li>
              <p>
                服务电话：0551-67122296
              </p>
              <p>
                服务邮箱：service@hddata.cn
              </p>
              <p>
                公众号：高维数据
                <img src="http://www.hddata.cn/img/qrcode.png">
              </p>
            </li>
          </ul>
        </dd>
      </dl>
      <!-- E 平台介绍 -->
    </div>
    <!-- S 底部footer -->
    <Footer />
    <!-- E 底部footer -->
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { urlSearchParams, getSession, setSession } from '@/utils/tools';
import { Footer } from '@/components'

const userInfo = {
  'userId': '2d481258a83a44d588b6b8ff71e70c68',
  'username': 'demo01',
  'email': 'zhangzhixiang@hddata.cn',
  'remark': '演示子账号',
  'firstLoginTime': '2020-05-08 15:29:48',
  'lastLoginTime': '2020-05-08 15:32:34',
  'depthForensicAmount': 100000,
  'depthForensicNumber': 11,
  'initialPwd': false,
  'status': '启用',
  'createTime': '2020-05-08 15:26:59',
  'updateTime': '2020-05-08 15:32:34',
  'orgId': '88a5d8334e8143c68dfc212f159bd09d',
  'orgName': '体验用户',
  'orgType': 2,
  'roleNames': ['USER_ORG_CHILD'],
  'diskUsage': null
}

const product = {
  'productId': '44c7972ecb0345168f974978a9d7f6e5',
  'productName': '屏摄溯源管理系统',
  'appAmount': 4,
  'forensicRecordAmount': 0,
  'createTime': '2018-09-01 16:04'
}

export default {
  name: 'Login',
  components: { Footer },
  data() {
    const validateName = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入账号'));
      } else {
        callback();
      }
    };
    const validatePwd = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入密码'));
      } else if (value.length < 8 || value.length > 18) {
        callback(new Error('密码长度限制8-18位'));
      } else {
        callback();
      }
    };
    return {
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ validator: validateName, trigger: 'blur' }],
        password: [{ validator: validatePwd, trigger: 'blur' }]
      }
    };
  },
  computed: {
    ...mapState({
      submitLoading: state => state.user.submitLoading
    })
  },
  created() {
    userInfo.username = urlSearchParams('acc');
    userInfo.token = urlSearchParams('token');
    const redirect = urlSearchParams('redirect');
    if (userInfo.token && redirect) {
      sessionStorage.clear();
      localStorage.clear();
      this.$store.commit('user/setToken', userInfo.token);
      this.$store.commit('user/setInfo', userInfo);
      // 获取产品
      this.getList().then((data) => {
        if (data.length > 0) {
          this.$store.commit('product/setProduct', data[0]);
          location.replace(
            `${location.protocol}//${location.host}${location.pathname}#/${redirect}`
          );
        }
      })
    }
  },
  mounted() {
    if (getSession('timeout') === '1') {
      setSession('timeout', '')
      this.$alert('因超时未操作，您已被登出，请重新登录', '超时登出', {
        confirmButtonText: '确定',
        showClose: false,
        center: true
      })
    }
  },
  methods: {
    ...mapActions({
      login: 'user/login',
      getList: 'product/getList'
    }),
    // 提交登录
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.login(this.form).then(res => {
            const data = res.data.data;
            setSession('showSurplusDaysTip', 1)
            if (data.initialPwd) return this.replaceTo('/initPsd');
            if (!data.initialPwd) return this.replaceTo('/');
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import '../../assets/scss/variable.scss';

#login.container {
  background-color: $whiteColor;
  .header {
    padding: 20px;
    color: $whiteColor;
    background: $primaryBgColor;
    background: linear-gradient(to right, $primaryBgColor 0%, $primaryLightBgColor 100%);
    .logo {
      display: block;
      padding: 2px 0;
      cursor: pointer;
      object-fit: contain;
    }
  }
  .wallpaper {
    display: flex;
    justify-content: center;
    flex-wrap: warp;
    padding: 80px 0;
    background: $primaryBgColor;
    background: linear-gradient(to right, $primaryBgColor 0%,$primaryLightBgColor 100%);
  }
  .login-bg {
    width: 748px;
    height: 552px;
    background: url(../../assets/imgs/login_adv.png) no-repeat 50%;
    background-size: 100% auto;
    margin-right: 185px;
  }

  @media (max-width: 1200px) {
    .login-bg {
      display: none;
    }
  }

  .form-content {
    width: 384px;
    height: 400px;
    display: flex;
    justify-content: flex-end;
    .el-form {
      width: 384px;
      height: 400px;
      background-color: $whiteColor;
      border-radius: 4px;
      padding-right: 0 !important;
      .title {
        margin: 61px auto 51px;
        width: 100%;
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        text-align: center;
        letter-spacing: 0px;
      }
      .login-btn {
        margin-top: 21px;
        margin-left: 40px;
        margin-right: 60px;
        margin-bottom: 81px;
        width: 300px;
        height: 40px;
        font-size: 16px;
        color: $whiteColor;
        font-weight: normal;
      }
      .account {
        width: 300px;
        height: 40px;
        margin: 0 auto;
      }
      .pwd {
        width: 300px;
        height: 40px;
        margin: 24px auto 18px;
      }
      .link-to {
        margin-left: 45px;
        width: 53px;
        height: 12px;
        font-size: 12px;
        color: #666666;
      }
      .right {
        float: right;
      }
    }
  }
  .introduce {
    padding-top: 30px;
    .introduce-item {
      width: 100%;
      padding-bottom: 30px;
      background-color: $whiteColor;
      max-width: 1195px;
      margin: 0 auto;
      img {
        max-width: 592px;
        object-fit: contain;
      }
      dt {
        height: 29px;
        line-height: 29px;
        margin: 0px 0 16px 0;
        text-align: center;
        font-size: 28px;
        color: #2cb2a3;
        letter-spacing: 2px;
        display: block;
      }
      dd {
        padding-top: 15px;
        font-size: 16px;
        left: 32px;
        color: #666;
        background: url(../../assets/imgs/login_icon1.png) no-repeat left top;
        li {
          line-height: 28px;
          margin-top: 15px;
          color: #666;
          * {
            vertical-align: middle;
          }
        }
        .thd-tt{
          margin-top:20px;
          font-weight: bold;
        }
        .text-list{
          text-indent: 2em;
        }
        .company-name {
          color: #999;
          margin-top: -2px;
          margin-right: 5px;
          font-size: 14px;
        }

        .user-icon {
          width: 15px;
          height: 16px;
          display: inline-block;
          margin-right: 5px;
          background: url(../../assets/imgs/user_icon1.png) no-repeat left top;
        }
      }
    }
  }

  .footer {
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #999;
    background-color: $bgColor;
  }
}
</style>
